import styled from 'styled-components';
import { rem } from 'polished';
import { BrowserUpdateTemplate } from './BrowserUpdateTemplate';

export const BrowserUpdateStyled = styled(BrowserUpdateTemplate)`
    
`;
